import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import messages from '../../../../../utils/translationMessages';
import { formatMessage } from '../../../../../utils/language';

import './styles.css';

export const MonthlyPrice = ({
  hiddenPrice,
  monthlyPrice,
  supportsTridentCalculator,
  showMonthlyPrice = true,
}) => {
  return showMonthlyPrice && supportsTridentCalculator && monthlyPrice ? (
    <div className="price-payments">
      <span className={classnames('payment-month', { 'hidden-price': hiddenPrice })}>
        ${monthlyPrice}/{formatMessage(messages.boatDetails.monthlyPrice)}
      </span>
    </div>
  ) : null;
};

MonthlyPrice.propTypes = {
  hiddenPrice: PropTypes.bool.isRequired,
  monthlyPrice: PropTypes.string,
  supportsTridentCalculator: PropTypes.bool,
  showMonthlyPrice: PropTypes.bool,
};
